import React from 'react'
import { TextField } from '@material-ui/core'

function ExtraInputField({ label, id, onChange, required, value }) {
  const handleChange = (event) => {
    onChange(event.target.value)
  }

  // make sure that the input field has red border if required and empty (spaces alone count as empty)
  const isEmpty = !String(value || '').trim()
  return (
    <TextField
      label={label}
      id={id}
      onChange={handleChange}
      fullWidth
      margin="normal"
      required={required}
      error={required && isEmpty}
      InputProps={{
        style: {
          borderColor: required && isEmpty ? 'red' : undefined,
        },
      }}
    />
  )
}

export default ExtraInputField
